module.exports = __webpack_public_path__ + "static/media/p10.75a5addd.jpeg";